import React, { useState, useEffect } from 'react';
import MetaTags from 'react-meta-tags';
import { Col, Container, Row, FormGroup, Alert } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Dropdown } from 'semantic-ui-react';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';
import { calculatorApi } from '../../services/CalculatorService';
import { countryOptionsPayoneer } from '../../helpers/country_helper_payoneer';

import Breadcrumbs from '../../components/Breadcrumb';
import PageLoader from '../../components/Loaders/newPageLoader';
import useLoadingProgress from '../../hooks/useLoadingProgress';

import box_weight from '../../assets/images/box-weight.png';
import fedex from '../../assets/images/calculator/fedex_icon.png';

export default function CalculatorFedex({ profileData, loading }) {
  const {
    data = [],
    isLoading,
    // isFetching,
    error,
    refetch
  } = calculatorApi.useFetchAllDataQuery(undefined, {
    refetchOnMountOrArgChange: false,
    refetchOnFocus: false
  });

  const [getRates, { isLoading: isFetching }] = calculatorApi.useGetRatesMutation();

  const [emsPrices, setEmsPricesData] = useState([]);
  const [boxSizes, setBoxSizesData] = useState([]);
  const [addDelsFields, setAddInputFields] = useState([{
    boxAmount: '1',
    boxSize: '',
    weight: '',
    boxSizeL: '',
    boxSizeW: '',
    boxSizeH: '',
    actualWeight: '',
  }]);
  const [errorMsg, setErrorMsg] = useState('');
  const [errors, setErrors] = useState([]);

  const { progress, step, visible } = useLoadingProgress({ isLoading, isFetching });
  useEffect(() => {
    if (data.destinations) {
      setEmsPricesData(JSON.parse(JSON.stringify(data.emsPrices)));
      setBoxSizesData(JSON.parse(JSON.stringify(data.boxSizes)));
    }
  }, [data]);

  const [rate, setRate] = useState(null);
  // useEffect(() => {
  //   const fetchExchangeRate = async () => {
  //     try {
  //       const res = await fetch('https://api.exchangerate.host/latest?base=KRW&symbols=USD');
  //       const data = await res.json();
  //       setRate(data.rates.USD);
  //     } catch (err) {
  //       console.error('Error fetching exchange rate:', err);
  //     }
  //   };

  //   fetchExchangeRate();
  // }, []);

  const [formState, setFormState] = useState({
    originCountry: 'KR',
    originPostalCode: '',
    destCountry: '',
    destPostalCode: '',
    // boxSize: '',
    // boxSizeL: '',
    // boxSizeW: '',
    // boxSizeH: '',
    // actualWeight: '',
  });
  /**
   * Adds a new input field object to the current state based on the selected delivery service.
   * 
   * If the selected delivery service (`delServ`) is 'Others', a new logistic input field object is added.
   * Otherwise, a new delivery input field object is added.
   * The function copies the existing input fields, appends a new field object with default values,
   * and updates the state with the new array.
   */
  const addInputField = () => {
    // Copy the current input fields state
    const newAddFields = [...addDelsFields];
      // Push a new input field state
      newAddFields.push({
        // Logistic fields
        boxAmount: '1',
        boxSize: '',
        weight: '',
        boxSizeL: '',
        boxSizeW: '',
        boxSizeH: '',
        actualWeight: '',
      });
    // Set the new state
    setAddInputFields(newAddFields);
  };
  /**
   * Removes an input field from the addDelsFields array at the specified index and updates the state.
   *
   * @param {number} index - The index of the input field to remove.
   */
  const removeInputField = (index) => {
    // Copy the current input fields state
    const newAddFields = [...addDelsFields];
    // Remove the input field at the specified index
    newAddFields.splice(index, 1);
    // Update state with modified input fields
    setAddInputFields(newAddFields);
  };
  const handleInputChange = (name, value) => {
    setFormState((prev) => ({
      ...prev,
      [name]: value.toUpperCase(),
    }));
  };
  const [postalCode, setPostalCode] = useState('');
  const handleInputDestChange = (name, value) => {
    console.log('handleInputDestChange:', name, value);
    setFormState((prev) => ({
      ...prev,
      [name]: value.toUpperCase()
    }));
    setPostalCode(      
      countryOptionsPayoneer.find(
        (o) => o.value?.toLowerCase() === value?.toLowerCase()
      )?.postalCode
    );
  };
  const handleCalculate = (e, index) => {
    const newAddFields = [...addDelsFields];
    const [boxNoStr = ""] = String(e.target.value).split("/");
    const boxNo = parseInt(boxNoStr, 10);

    const sel = boxSizes.find(v => v.boxSizeNo === boxNo);
    if (!sel) return; // nothing to update if not found

    const L = Number(sel.length) || 0;
    const W = Number(sel.width)  || 0;
    const H = Number(sel.height) || 0;

    const volumeWeight = (L * W * H) / 5000;

    newAddFields[index]['boxSize'] = boxNoStr;
    newAddFields[index]['boxSizeL'] = L;
    newAddFields[index]['boxSizeW'] = W;
    newAddFields[index]['boxSizeH'] = H;
    newAddFields[index]['actualWeight'] = volumeWeight;
    setAddInputFields(newAddFields);
    
    setFormState(prev => ({
      ...prev,
      // boxSizeL: L,
      // boxSizeW: W,
      // boxSizeH: H,
      // boxSize: boxNoStr,
      // actualWeight: volumeWeight,
      display: false,
    }));
  };

  const handleActualWeightCalc = (e, index) => {
    const newAddFields = [...addDelsFields];

    const weight = Number(e.target.value) || 0;

    newAddFields[index].actualWeight = weight;

    setAddInputFields(newAddFields);

    setFormState(prev => ({
      ...prev,
      display: false,
    }));
  };

  const handleValidCalculateFedex = async (e, values) => {
    const shipingInfo = {
      originCountry: formState.originCountry,
      originPostalCode: values.originPostalCode,

      destCountry:
        formState.destCountry === 'UK'
          ? 'GB'
          : formState.destCountry,

      destPostalCode: values.destPostalCode,

      packages: addDelsFields.flatMap((box, index) => {
        const boxAmount = Number(values[`boxAmount${index}`]) || 1;

        return Array.from({ length: boxAmount }, () => ({
          packageWeight: Number(values[`weight${index}`]),
          dimensions: {
            length: Number(box.boxSizeL),
            width: Number(box.boxSizeW),
            height: Number(box.boxSizeH),
          }
        }));
      })
    };
    console.log('FEDEX REQUEST:', shipingInfo);
    try {
      const ratesResp = await getRates(shipingInfo).unwrap();

      const usdRateResp = await fetch(
        'https://open.er-api.com/v6/latest/KRW'
      );

      const data = await usdRateResp.json();

      setRate(data.rates.USD);

      setFormState(prev => ({
        ...prev,
        baseRate: ratesResp.baseRate,
        fuelSurcharge: ratesResp.fuelSurcharge,
        demandSurcharge: ratesResp.demandSurcharge,
        volumeDiscount: ratesResp.volumeDiscount,
        estimatedTotal: ratesResp.estimatedTotal,
        display: true,
      }));

      setErrors([]);

    } catch (error) {
      const formattedErrors = error.data.errors.map(err => ({
        ...err,
        message: err.message
      }));

      console.log('errors:', error.data.errors);

      setErrors(formattedErrors);
    }
    // const shipingInfo = {
    //   originCountry: formState.originCountry,
    //   originPostalCode: values.originPostalCode,
    //   destCountry: formState.destCountry === 'UK' ? 'GB' : formState.destCountry,
    //   destPostalCode: values.destPostalCode,
    //   packageWeight: formState.actualWeight,
    //   dimensions: {
    //     length: formState.boxSizeL,
    //     width: formState.boxSizeW,
    //     height: formState.boxSizeH,
    //   }
    // }
    // try {
    // // { originCountry: 'KR', originPostalCode: '14556', destCountry: 'CA', destPostal: 'L6A0L2',  packageWeight: 6.35, dimensions: { length: 34, width: 25, height: 21 } }
    //   const ratesResp = await getRates(shipingInfo).unwrap()
    //   const usdRateResp = await fetch('https://open.er-api.com/v6/latest/KRW');
    //   const data = await usdRateResp.json();
    //   setRate(data.rates.USD);
    //   setFormState(prev => ({
    //     ...prev,
    //     baseRate: ratesResp.baseRate,
    //     fuelSurcharge: ratesResp.fuelSurcharge,
    //     demandSurcharge: ratesResp.demandSurcharge,
    //     volumeDiscount: ratesResp.volumeDiscount,
    //     estimatedTotal: ratesResp.estimatedTotal,
    //     display: true,
    //   }));
    //   setErrors([])
    // } catch (error) {
    //   const formattedErrors = error.data.errors.map(err => {
    //     return {
    //       ...err,
    //       message: err.message
    //     };
    //   });
    //   console.log('errors:', error.data.errors);
    //   setErrors(formattedErrors)
    //   // console.error(error);
    //   // showToast('Failed to fetch information', 'error');
    // }
  }
  const getCountryName = (country) => {
    const match = countryOptionsPayoneer.find(
      (o) => o.value.toLowerCase() === country.toLowerCase()
    );
    return match ? match.text : country;
  };
  const actualWeights = emsPrices.filter((v, i, a) => a.findIndex((v2) => v2.netWeightEms === v.netWeightEms) === i);
  console.log(addDelsFields)
  return (
    <React.Fragment>
      <PageLoader progress={progress} step={step} visible={visible} />
      <div className='page-content'>
        <MetaTags>
          <title>Fedex Calculator</title>
        </MetaTags>
          <Container fluid>
            {profileData.permissions.includes('shippingCalcAccess') ? (
              <>
              <Breadcrumbs title='Calculator' breadcrumbItem='Fedex Calculator' />
              <div id='card-section'>
                <Row id='card-section' style={{overflow: 'auto'}}>
                  <Col lg='2'></Col>
                  <Col lg='8'>
                    <div className='screen'>
                      <AvForm onValidSubmit={handleValidCalculateFedex} style={{ height: '100%' }}>
                        <Row style={{ height: '100%' }}>
                          <Col lg='6' style={{ height: '100%' }}>
                            <div className="area">
                              {formState.display && formState.estimatedTotal && (
                              <>
                                <Row className="ms-2 me-2 mt-4 area-text">
                                  <hr className='area-line mt-4' />
                                </Row>
                                <Row className="ms-2 me-2 mt-4 area-text">
                                  <Col md={12}>
                                    <Row>
                                      <Col md={4} className="ps-5 pe-0 text-start">
                                      </Col>
                                      <Col md={4} className="ps-5 pe-0 text-start" style={{ margin: 'auto' }}>
                                      </Col>
                                      <Col md={4} className="ps-5 pe-0 text-start" >
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col md={2} className="ps-5 pe-0 text-start">
                                      </Col>
                                      <Col md={8} className="ps-0 pe-0 pb-4 text-center" style={{ margin: 'auto' }}>
                                        <img src={fedex} width="100" height="100" alt="" />
                                        <h2 className='text-center pb-2 area-text-title'><b>{getCountryName(formState.originCountry)} {formState.originPostalCode} <i className='mdi mdi-arrow-right font-size-24'></i> {getCountryName(formState.destCountry)} {formState.destPostalCode}</b></h2>
                                      </Col>
                                      <Col md={2} className="ps-5 pe-0 text-start" >
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col md={7} className="ps-3 pt-2 text-start">
                                        <h3 className="area-text-label">Shipping Costs:</h3>
                                        <h5 className="area-text-label">Base Rate:</h5>
                                        <h5 className="area-text-label">Fuel Surcharge:</h5>
                                        <h5 className="area-text-label">Demand Surcharge:</h5>
                                        
                                        <h3 className="area-text-value">Total Discount:</h3>
                                        <h5 className="area-text-label">Volume Discount:</h5>
                                        <h3 className="area-text-value font-size-20">Estimated Total Cost:</h3>
                                      </Col>
                                      <Col md={5} className="ps-0 pt-2 text-start">
                                        <h3 className="area-text-label"><span className=""><NumberFormat value={formState.baseRate+formState.demandSurcharge+formState.fuelSurcharge} displayType='text' thousandSeparator={true} prefix='₩' /></span></h3>
                                        <h5 className="area-text-label"><span className=""><NumberFormat value={formState.baseRate} displayType='text' thousandSeparator={true} prefix='₩' /></span></h5>
                                        <h5 className="area-text-label"><span className=""><NumberFormat value={formState.fuelSurcharge} displayType='text' thousandSeparator={true} prefix='₩' /></span></h5>
                                        <h5 className="area-text-label"><span className=""><NumberFormat value={formState.demandSurcharge} displayType='text' thousandSeparator={true} prefix='₩' /></span></h5>
                                        
                                        <h3 className="area-text-value"><span className=""><NumberFormat value={formState.volumeDiscount} displayType='text' thousandSeparator={true} prefix='₩' /></span></h3>
                                        <h5 className="area-text-label"><span className="">- <NumberFormat value={formState.volumeDiscount} displayType='text' thousandSeparator={true} prefix='₩' /></span></h5>
                                        <h3 className="area-text-value font-size-20">
                                          <span className="pe-4"><NumberFormat value={formState.estimatedTotal+15000} displayType='text' thousandSeparator={true} prefix='₩' />  </span>
                                          (<NumberFormat value={((formState.estimatedTotal+15000)*rate).toFixed(2)} displayType='text' thousandSeparator={true} prefix='$' />)
                                        </h3>
                                      </Col>
                                    </Row>
                                  </Col>
                                  <hr className='area-line mt-4' />
                                </Row>
                                <Row>
                                  <Col md={12} className="ps-3 pt-2 text-start">
                                    <Row>
                                      <Col md={12} className="ps-5 pe-5 text-start " style={{ margin: 'auto' }}>
                                        <Alert color="warning" >
                                          <h5 className="area-text-value font-size-14"><span className="">* Extra fees may apply for remote area delivery, oversized packages, residential addresses and inbound shipments. That is why we add a flat rate of <NumberFormat value='15000' displayType='text' thousandSeparator={true} prefix='₩' /> to all Fedex shipments.</span></h5>
                                        </Alert>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </>
                              )}
                            </div>
                          </Col>
                          <Col lg='6' className='ps-0'>
                            <Row className='mt-5 ms-0 me-1'>                      
                              <Col md={6}>
                                <FormGroup className='mb-3'>
                                  <Dropdown
                                    placeholder='Origin Country'
                                    fluid
                                    search
                                    selection
                                    options={countryOptionsPayoneer}
                                    className="calculator-select"
                                    name='originCountry'
                                    defaultValue='kr'
                                    onChange={(e, data) => handleInputChange(data.name, data.value)}
                                    id='originCountry'
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={6}>
                                <FormGroup className='mb-3'>
                                  <AvField name='originPostalCode' className="calculator-select" type='text' id='originPostalCode' required defaultValue='14556' placeholder='Ship From Postal Code'/>
                                </FormGroup>
                              </Col>  
                            </Row>
                            <Row className='mt-5 ms-0 me-1'>                              
                              <Col md={6}>
                                <FormGroup className='mb-3'>
                                  <Dropdown
                                    placeholder='Destination Country'
                                    fluid
                                    search
                                    selection
                                    options={countryOptionsPayoneer}
                                    className="calculator-select"
                                    name='destCountry'
                                    onChange={(e, data) => handleInputDestChange(data.name, data.value)}
                                    id='destCountry'
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={6}>
                                <FormGroup className='mb-3'>
                                  <AvField name='destPostalCode' className="calculator-select" type='text' id='destPostalCode' required placeholder='Decstination Postal Code' value={postalCode}/>
                                </FormGroup>
                              </Col>  
                            </Row>
                            {addDelsFields.map((field, index) => (
                              <React.Fragment key={index}>  
                                <Row className='mt-5 ms-0 me-1'>
                                  <Col md={3} >
                                    <FormGroup className='mb-3'>
                                      <AvField name={`boxAmount${index}`} className="calculator-select" type='number' id={`boxAmount${index}`} required placeholder='Box Amount' min="1" step="1" defaultValue="1"/>
                                    </FormGroup>
                                  </Col>
                                  <Col md={3} >
                                    <FormGroup className='mb-3'>
                                      <AvField name={`boxSize${index}`} className="calculator-select" type='select' id={`boxSize${index}`} required onChange={(e) => handleCalculate(e, index)}>
                                        <option>Box Size</option>
                                        {boxSizes.map((val, key) => (
                                          <option key={key} value={val.boxSizeNo + '/' + val.volWeight}>
                                            {val.boxSizeNo}
                                          </option>
                                        ))}
                                      </AvField>
                                    </FormGroup>
                                  </Col>
                                  <Col md={4}>
                                    <FormGroup className='mb-3'>
                                      <AvField name={`weight${index}`} className="calculator-select" type='select' id={`weight${index}`} onChange={(e) => handleActualWeightCalc(e, index)}>
                                        <option>Actual Weight</option>
                                        {actualWeights.map((val, key) => (
                                          <option key={key} value={val.netWeightEms}>
                                            {val.netWeightEms}
                                          </option>
                                        ))}
                                      </AvField>
                                    </FormGroup>
                                  </Col>
                                  {index === addDelsFields.length - 1 && (
                                    <Col md={1} className='ps-0 mt-0'>
                                      <div className="calculator-button pb-4" >
                                        <button  className='btn-work text-success' onClick={addInputField}>
                                          <i className='mdi mdi-plus font-size-24'></i>
                                        </button>
                                      </div>
                                    </Col>
                                  )}
                                  {index !== 0 && (
                                    <Col md={1} className='ps-0 mt-0'>
                                      <div className="calculator-button pb-4" >
                                        <button className='btn-work text-danger' onClick={() => removeInputField(index)}>
                                          <i className='mdi mdi-delete font-size-24' id='deletetooltip'></i>
                                        </button>
                                      </div>
                                    </Col>
                                  )}
                                </Row>
                                {field.boxSizeL && (
                                <Row className='ms-0'>
                                  <Col md={7} className="ps-4 pt-4 pe-0">
                                    <Row className='calculator-text'>
                                      <Col md={1}>
                                        <i className='bx bx-chevron-down-square font-size-20 mt-3 ms-1 me-2' />
                                      </Col>
                                      <Col md={11}>
                                        <h5 className='mt-3'>
                                          : <b>{field.boxSizeL}cm</b> * <b>{field.boxSizeW}cm</b> * <b>{field.boxSizeH}cm</b> / <b>5000</b> =<b>{field.volumeWeight}</b>
                                        </h5>
                                      </Col>
                                    </Row>
                                  </Col>
                                  <Col md={5} className="ps-0">
                                    <div className="weight-wrapper">
                                      <img
                                        src={box_weight}
                                        className="weight-image"
                                        alt=""
                                      />

                                      <div className="weight-block">
                                        <p>{field.actualWeight.toFixed(2)} </p>
                                      </div>
                                      <div className="weight-block-kg">
                                        <p>kg</p>
                                      </div>
                                    {/* 
                                      <i
                                        className="fas fa-info-circle weight-info"
                                        data-tip="Chosen weight - the largest amount<br />between Gross Weight and Volume Weight"
                                        data-iscapture="true"
                                      /> */}
                                    </div>
                                  </Col>
                                  {/* <hr className='icon' /> */}
                                </Row> 
                                )}
                              </React.Fragment>
                            ))}
                            <Row className='ms-0 me-2 mt-4'>
                              <Col md={12}>
                                <div className="calculator-button pb-4" >
                                  <button className='btn-work' style={{ width: '100%' }}>Calculate </button>
                                </div>
                                {errors.length > 0 && errors.map((msg, i) => (<Alert color="danger" key={i}>{msg.message}</Alert>))}
                              </Col>
                            </Row>  
                          </Col>
                        </Row>
                      </AvForm>
                    </div>
                  </Col>
                  <Col lg='2'></Col>
                </Row>
              </div>
              </>
            ) : (
              <Alert color='danger'> You do not have access to this page. </Alert>
            )}
          </Container>
      </div>
    </React.Fragment>
  );
}